import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
} from "@angular/core";
import { PopoverService } from "../../../components/popover/popover.service";
import { ToolbarUserDropdownComponent } from "./toolbar-user-dropdown/toolbar-user-dropdown.component";
import icPerson from "@iconify/icons-ic/twotone-person";
import { AuthService } from "src/app/pages/auth/authServices";
import { Subscription } from "rxjs";
import { AdminProfileService } from "src/app/pages/auth/profile-tab/api.service";
import { Admins } from "src/app/pages/auth/profile-tab/model";

@Component({
  selector: "vex-toolbar-user",
  templateUrl: "./toolbar-user.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToolbarUserComponent implements OnInit {
  userIsAuthenticated = false;
  userName: string;
  userId: string;
  
  dropdownOpen: boolean;
  icPerson = icPerson;
  data: Admins;
  roleName: string;
  isLoading: boolean;
  private authListenerSubs: Subscription;
  private imageUpdatedSub: Subscription;

  constructor(
    private popover: PopoverService,
    private cd: ChangeDetectorRef,
    private authService: AuthService,
    public service: AdminProfileService
  ) {}

  ngOnInit() {
    this.userName = this.authService.getuserName() || localStorage.getItem('username') || '';
    this.roleName = this.authService.getRoleName() || localStorage.getItem('roleName') || '';
    this.initializeUserData();
    // update admin data when profile image or auth status changes
    this.imageUpdatedSub = this.authService.imageUpdated$.subscribe(() => {
      this.isLoading =  true;
      this.getAdminData();
    });
  }

  initializeUserData() {
    this.isLoading = true; 

    this.userIsAuthenticated = this.authService.getIsAuth();
    this.userName = this.authService.getuserName() || localStorage.getItem('username') || '';
    this.userId = this.authService.getUserId();

    this.authListenerSubs = this.authService.getAuthStatusListener().subscribe((isAuthenticated) => {
      this.userIsAuthenticated = isAuthenticated;
      if (isAuthenticated) {
        this.userId = this.authService.getUserId() || localStorage.getItem('userId') || '';
        this.userName = this.authService.getuserName() || localStorage.getItem('username') || '';
        this.roleName = this.authService.getRoleName() || localStorage.getItem('roleName') || '';
        this.getAdminData();
      }
      this.cd.markForCheck();
    });

    this.getAdminData();
  }

  // Fetch admin data from API
  getAdminData() {
    const userId = this.authService.getUserId() || localStorage.getItem('userId') || this.userId;
    if (!userId) {
      this.isLoading = false;
      this.cd.markForCheck();
      return;
    }
    this.userId = userId;

    this.service.getByID(userId).subscribe({
      next: (response) => {
        this.data = response.data.data;
        this.isLoading = false;
        this.cd.markForCheck(); 
      },
      error: () => {
        this.isLoading = false; 
        this.data = null; 
        this.cd.markForCheck();
      }
    });
  }
  handleImageError(event: Event) {
    (event.target as HTMLImageElement).src = ''; 
  }
  showPopover(originRef: HTMLElement) {
    this.dropdownOpen = true;
    this.cd.markForCheck();

    const popoverRef = this.popover.open({
      content: ToolbarUserDropdownComponent,
      origin: originRef,
      offsetY: 12,
      position: [
        {
          originX: "center",
          originY: "top",
          overlayX: "center",
          overlayY: "bottom",
        },
        {
          originX: "end",
          originY: "bottom",
          overlayX: "end",
          overlayY: "top",
        },
      ],
    });

    popoverRef.afterClosed$.subscribe(() => {
      this.dropdownOpen = false;
      this.cd.markForCheck();
    });
  }

  ngOnDestroy(): void {
    if (this.authListenerSubs) this.authListenerSubs.unsubscribe();
    if (this.imageUpdatedSub) this.imageUpdatedSub.unsubscribe();
  }
}
